import { Component } from '@angular/core';
import { ConfirmDialogService, ConfirmDialogState } from './confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  state: ConfirmDialogState | null = null;

  constructor(private confirmDialog: ConfirmDialogService) {
    this.confirmDialog.state$.subscribe((state) => {
      this.state = state;
    });
  }

  onCancel(): void {
    this.confirmDialog.dismiss();
  }

  onConfirm(): void {
    this.confirmDialog.accept();
  }
}
